import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    baseAPI: 'https://api.itsasmileairport.com',//https://api.itsasmileairport.com    OR    http://localhost:8081
    count: 0,
  },
  mutations: {
    increment (state){
      state.count++
    }
  },
  actions: {
  },
  modules: {
  }
})
